import {
  SEARCH_QC,
  SEARCH_QC_ERROR,
  SEARCH_QC_IN_PROGRESS,
} from '../actions/types';

const initialState = {
  qualityCertResults: [],
  qcErrored: false,
  qcSearchInProgress: false,
};

export default function (state, action) {
  state = state || initialState;
  switch (action.type) {
    case SEARCH_QC_IN_PROGRESS:
      return {
        ...state,
        qualityCertResults: [],
        qcSearchInProgress: true,
      };
    case SEARCH_QC:
      return {
        ...state,
        qualityCertResults: action.payload,
        qcErrored: false,
        qcSearchInProgress: false,
      };
    case SEARCH_QC_ERROR:
      return {
        ...state,
        qcErrored: action.payload,
        qcSearchInProgress: false,
      };
    default:
      return state;
  }
}
